// @flow
import React from 'react'
import FilterPill from 'src/components/_generic/filters/filter-pill'
import { useGetManyVendors } from 'src/api/vendors/useGetManyVendors'

type Props = {
	filters: [],
	setFilters: () => any,
}

const RenderVendorPills = ({ filters, setFilters }: Props) => {
	const { vendors } = useGetManyVendors(filters?.vendors)

	const handleFilterRemove = (filter) => {
		let activeVendorFilters = filters?.vendors?.filter(
			(vendor) => '' + vendor !== '' + filter
		)
		setFilters({ ...filters, vendors: activeVendorFilters })
	}

	let vendorPills = vendors?.filter((vendor) =>
		filters?.vendors?.includes(vendor?.id)
	)

	return (
		vendorPills?.map((vendor) => {
			return (
				<FilterPill
					filter={vendor?.name}
					filterType={'VENDOR'}
					onRemove={() => handleFilterRemove(vendor?.id)}
					key={`vendor-badge-${vendor?.id}`}
				/>
			)
		}) ?? null
	)
}

export default RenderVendorPills
